import React from 'react';
import s from './Dashboard.module.css';
import { Icons } from '../Sidebar/Icons';
import { useStore } from '../../hooks/useStore';
import { fmtBRL, today } from '../../utils/helpers';

export function Dashboard({ onNav }) {
  const { clientes, agendamentos, acesso } = useStore();
  const tstr = today();
  const todayAgs = agendamentos.filter(a => a.data === tstr && a.status !== 'finalizado');
  const receita  = agendamentos.filter(a => a.status === 'finalizado').reduce((s, a) => s + Number(a.valor || 0), 0);

  const isTrial   = acesso?.status === 'trial';
  const dias      = acesso?.dias_trial_restantes ?? 0;
  const urgente   = dias <= 3;
  const muitoUrgente = dias === 0;

  return (
    <div>

      {/* Card de trial — só aparece se estiver no free */}
      {isTrial && (
        <div style={{
          background:    muitoUrgente ? '#fef2f2' : urgente ? '#fffbeb' : '#eff6ff',
          border:        `0.5px solid ${muitoUrgente ? '#fecaca' : urgente ? '#fde68a' : '#bfdbfe'}`,
          borderRadius:  'var(--r-lg)',
          padding:       '18px 20px',
          marginBottom:  20,
          display:       'flex',
          alignItems:    'center',
          justifyContent:'space-between',
          gap:           16,
          flexWrap:      'wrap',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            {/* Ícone circular com contagem */}
            <div style={{
              width: 54, height: 54, borderRadius: '50%', flexShrink: 0,
              background:  muitoUrgente ? '#dc2626' : urgente ? '#d97706' : '#2563eb',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
            }}>
              <span style={{ fontSize: 18, fontWeight: 800, color: '#fff', lineHeight: 1 }}>
                {dias}
              </span>
              <span style={{ fontSize: 9, color: 'rgba(255,255,255,.8)', lineHeight: 1, marginTop: 1 }}>
                {dias === 1 ? 'dia' : 'dias'}
              </span>
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: muitoUrgente ? '#dc2626' : urgente ? '#92400e' : '#1e40af' }}>
                {muitoUrgente
                  ? '⚠️ Seu período gratuito termina hoje!'
                  : urgente
                  ? `⏳ Apenas ${dias} dia${dias > 1 ? 's' : ''} restante${dias > 1 ? 's' : ''} no período gratuito`
                  : `🎁 ${dias} dias restantes no período gratuito`
                }
              </div>
              <div style={{ fontSize: 12, color: muitoUrgente ? '#ef4444' : urgente ? '#a16207' : '#3b82f6', marginTop: 3 }}>
                {muitoUrgente
                  ? 'Assine agora para não perder o acesso'
                  : 'Assine antes do fim do trial e continue sem interrupções'
                }
              </div>
            </div>
          </div>
          <button
            onClick={() => onNav && onNav('assinatura')}
            style={{
              background: muitoUrgente ? '#dc2626' : urgente ? '#d97706' : '#2563eb',
              color: '#fff', border: 'none', borderRadius: 8,
              padding: '9px 20px', fontSize: 13, fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            Ver planos →
          </button>
        </div>
      )}

      {/* Stats */}
      <div className={s.g3}>
        <Stat icon={<Icons.Users/>}    val={clientes.length}   lbl="Total de Clientes"    bg="#eff6ff"/>
        <Stat icon={<Icons.Calendar/>} val={todayAgs.length}   lbl="Agendamentos Hoje"    bg="#f0fdf4"/>
        <Stat icon={<Icons.Money/>}    val={fmtBRL(receita)}   lbl="Receita Total"        bg="#fffbeb"/>
      </div>

      {/* Agenda do dia */}
      {todayAgs.length > 0
        ? <div className={s.card} style={{ marginTop: 16 }}>
            <div className={s.ch}><div className={s.ct}><Icons.Clock/>Agenda de Hoje</div></div>
            <div className={s.tw}><table className={s.tb}>
              <thead><tr><th>Hora</th><th>Cliente</th><th>Serviço</th><th>Valor</th></tr></thead>
              <tbody>
                {[...todayAgs].sort((a, b) => a.hora > b.hora ? 1 : -1).map(a => (
                  <tr key={a.id}>
                    <td><strong>{a.hora}</strong></td>
                    <td>{a.clienteNome}</td>
                    <td>{a.servico}</td>
                    <td style={{ fontWeight: 600, color: 'var(--green)' }}>{fmtBRL(a.valor)}</td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          </div>
        : <div className={s.card} style={{ marginTop: 16 }}>
            <div className={s.emp}><Icons.Calendar/><p>Nenhum agendamento para hoje.</p></div>
          </div>
      }
    </div>
  );
}

function Stat({ icon, val, lbl, bg }) {
  return (
    <div style={{ background: '#fff', borderRadius: 'var(--r-lg)', border: '0.5px solid var(--g200)', boxShadow: 'var(--shadow-sm)', padding: '18px 20px' }}>
      <div style={{ width: 38, height: 38, background: bg, borderRadius: 'var(--r-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, color: 'var(--blue)' }}>{icon}</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--g800)', marginBottom: 2 }}>{val}</div>
      <div style={{ fontSize: 12.5, color: 'var(--g500)' }}>{lbl}</div>
    </div>
  );
}
